(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aabha-announcement"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aabha-announcement')) {
    customElements.define(
      'aabha-announcement',
      class AabhaAnnouncement extends HTMLElement {
        connectedCallback() {
          this.messages = Array.from(this.querySelectorAll('.aabha-announce__msg'));
          if (this.messages.length < 2) return;
          this.index = 0;
          const speed = parseInt(this.dataset.speed, 10) || 3500;
          this.timer = setInterval(() => this.next(), speed);
        }

        disconnectedCallback() {
          clearInterval(this.timer);
        }

        next() {
          const current = this.messages[this.index];
          current.classList.remove('is-active');
          current.setAttribute('aria-hidden', 'true');

          this.index = (this.index + 1) % this.messages.length;

          const upcoming = this.messages[this.index];
          upcoming.removeAttribute('aria-hidden');
          upcoming.classList.add('is-active');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aabha-header"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aabha-header')) {
    customElements.define(
      'aabha-header',
      class AabhaHeader extends HTMLElement {
        connectedCallback() {
          this.drawer = this.querySelector('.aabha-header__drawer');
          this.burger = this.querySelector('.aabha-header__burger');
          this.closeBtn = this.querySelector('.aabha-header__close');

          this.onScroll = () => this.classList.toggle('is-scrolled', window.scrollY > 8);
          this.onKey = (event) => {
            if (event.key === 'Escape') this.closeDrawer();
          };

          this.onScroll();
          window.addEventListener('scroll', this.onScroll, { passive: true });
          this.burger?.addEventListener('click', () => this.openDrawer());
          this.closeBtn?.addEventListener('click', () => this.closeDrawer());
          this.querySelectorAll('.aabha-header__drawer-link').forEach((link) =>
            link.addEventListener('click', () => this.closeDrawer())
          );
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          document.removeEventListener('keydown', this.onKey);
          document.documentElement.style.overflow = '';
        }

        openDrawer() {
          if (!this.drawer) return;
          this.drawer.hidden = false;
          requestAnimationFrame(() => this.classList.add('is-open'));
          this.burger?.setAttribute('aria-expanded', 'true');
          document.documentElement.style.overflow = 'hidden';
          document.addEventListener('keydown', this.onKey);
        }

        closeDrawer() {
          if (!this.drawer) return;
          this.classList.remove('is-open');
          this.burger?.setAttribute('aria-expanded', 'false');
          document.documentElement.style.overflow = '';
          document.removeEventListener('keydown', this.onKey);
          const drawer = this.drawer;
          setTimeout(() => {
            if (!this.classList.contains('is-open')) drawer.hidden = true;
          }, 300);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aabha-pdp-before-after"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aabha-before-after')) {
    customElements.define(
      'aabha-before-after',
      class AabhaBeforeAfter extends HTMLElement {
        connectedCallback() {
          this.range = this.querySelector('.aabha-pdp-ba__range');
          this.set(50);

          this.range?.addEventListener('input', () => this.set(this.range.value));

          this.onPointer = (event) => {
            const rect = this.getBoundingClientRect();
            const x = ((event.clientX - rect.left) / rect.width) * 100;
            const clamped = Math.max(0, Math.min(100, x));
            if (this.range) this.range.value = clamped;
            this.set(clamped);
          };

          this.addEventListener('pointerdown', (event) => {
            this.setPointerCapture(event.pointerId);
            this.dragging = true;
            this.onPointer(event);
          });
          this.addEventListener('pointermove', (event) => {
            if (this.dragging) this.onPointer(event);
          });
          this.addEventListener('pointerup', () => {
            this.dragging = false;
          });
        }

        set(value) {
          this.style.setProperty('--pos', `${value}%`);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aabha-pdp-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('aabha-pdp-hero')) {
    customElements.define(
      'aabha-pdp-hero',
      class AabhaPdpHero extends HTMLElement {
        connectedCallback() {
          this.main = this.querySelector('.aabha-pdp-hero__main');
          this.thumbs = Array.from(this.querySelectorAll('.aabha-pdp-hero__thumb'));
          this.slides = Array.from(this.querySelectorAll('.aabha-pdp-hero__slide'));
          this.dots = Array.from(this.querySelectorAll('.aabha-pdp-hero__dot'));

          // Desktop: thumb click selects the active image
          this.thumbs.forEach((thumb) =>
            thumb.addEventListener('click', () => this.select(thumb.dataset.index))
          );

          // Mobile carousel: dot click scrolls; scroll syncs dots/active state
          this.dots.forEach((dot) =>
            dot.addEventListener('click', () => this.scrollToIndex(parseInt(dot.dataset.index, 10)))
          );
          this.main?.addEventListener('scroll', () => this.onScroll(), { passive: true });

          // Tap any gallery image -> open full-screen lightbox at that index
          this.slides.forEach((slide) =>
            slide.addEventListener('click', () => this.openLightbox(parseInt(slide.dataset.index, 10)))
          );

          // Lightbox
          this.lightbox = this.querySelector('.aabha-pdp-hero__lightbox');
          this.lbTrack = this.querySelector('.aabha-pdp-hero__lightbox-track');
          this.lbDots = Array.from(this.querySelectorAll('.aabha-pdp-hero__lightbox-dot'));
          this.onKey = (event) => {
            if (event.key === 'Escape') this.closeLightbox();
          };
          this.querySelector('.aabha-pdp-hero__lightbox-close')?.addEventListener('click', () =>
            this.closeLightbox()
          );
          this.lbTrack?.addEventListener('scroll', () => this.onLbScroll(), { passive: true });

          // Quantity stepper (wired into the add-to-cart form)
          this.qtyCount = this.querySelector('.aabha-pdp-hero__qty-count');
          this.qtyInput = this.querySelector('.aabha-pdp-hero__qty-input');
          this.querySelectorAll('.aabha-pdp-hero__qty-btn').forEach((btn) =>
            btn.addEventListener('click', () => this.step(parseInt(btn.dataset.step, 10)))
          );
        }

        disconnectedCallback() {
          document.removeEventListener('keydown', this.onKey);
          document.documentElement.style.overflow = '';
        }

        // Desktop: switch the single active image
        select(index) {
          this.thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.index === index));
          this.slides.forEach((s) => s.classList.toggle('is-active', s.dataset.index === index));
        }

        scrollToIndex(i) {
          if (!this.main) return;
          this.main.scrollTo({ left: i * this.main.clientWidth, behavior: 'smooth' });
        }

        onScroll() {
          if (!this.main || !this.main.clientWidth) return;
          this.setActive(Math.round(this.main.scrollLeft / this.main.clientWidth));
        }

        setActive(i) {
          this.dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
          this.thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
          this.slides.forEach((s, n) => s.classList.toggle('is-active', n === i));
        }

        openLightbox(index) {
          if (!this.lightbox) return;
          this.lightbox.hidden = false;
          document.documentElement.style.overflow = 'hidden';
          document.addEventListener('keydown', this.onKey);
          if (this.lbTrack) {
            requestAnimationFrame(() => {
              this.lbTrack.scrollLeft = index * this.lbTrack.clientWidth;
              this.setLbActive(index);
            });
          }
        }

        closeLightbox() {
          if (!this.lightbox) return;
          this.lightbox.hidden = true;
          document.documentElement.style.overflow = '';
          document.removeEventListener('keydown', this.onKey);
        }

        onLbScroll() {
          if (!this.lbTrack || !this.lbTrack.clientWidth) return;
          this.setLbActive(Math.round(this.lbTrack.scrollLeft / this.lbTrack.clientWidth));
        }

        setLbActive(i) {
          this.lbDots.forEach((d, n) => d.classList.toggle('is-active', n === i));
        }

        step(delta) {
          if (!this.qtyCount) return;
          const next = Math.max(1, (parseInt(this.qtyCount.textContent, 10) || 1) + delta);
          this.qtyCount.textContent = next;
          if (this.qtyInput) this.qtyInput.value = next;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-lifting2-buybox"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__l2Buybox) return;
    window.__l2Buybox = true;

    function initGallery(root) {
      var gallery = root.querySelector('[data-l2-gallery]');
      if (!gallery) return;
      var main = gallery.querySelector('[data-l2-main]');
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-l2-slide]'));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-l2-thumb]'));
      var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-l2-dot]'));
      var n = slides.length;
      if (!n) return;
      var index = 0;

      function desktop() { return window.matchMedia('(min-width: 768px)').matches; }

      function setActive(i) {
        index = (i % n + n) % n;
        slides.forEach(function (s, si) { s.classList.toggle('is-active', si === index); });
        thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === index); });
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
      }

      function goTo(i) {
        var target = (i % n + n) % n;
        if (!desktop() && main && slides[target]) {
          main.scrollTo({ left: slides[target].offsetLeft, behavior: 'smooth' });
        }
        setActive(target);
      }

      if (main) {
        main.addEventListener('scroll', function () {
          if (desktop()) return;
          var w = main.clientWidth || 1;
          var i = Math.round(main.scrollLeft / w);
          if (i !== index) setActive(i);
        }, { passive: true });
      }
      thumbs.forEach(function (t, ti) { t.addEventListener('click', function () { goTo(ti); }); });
      dots.forEach(function (d, di) { d.addEventListener('click', function () { goTo(di); }); });

      // full-screen lightbox
      var lb = root.querySelector('[data-l2-lightbox]');
      if (lb) {
        var lbTrack = lb.querySelector('[data-l2-lb-track]');
        var lbSlides = Array.prototype.slice.call(lb.querySelectorAll('[data-l2-lb-slide]'));
        var lbDots = Array.prototype.slice.call(lb.querySelectorAll('[data-l2-lb-dot]'));
        var lbClose = lb.querySelector('[data-l2-lb-close]');

        function syncLbDots(i) {
          lbDots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
        }
        function openLb(i) {
          lb.hidden = false;
          document.documentElement.style.overflow = 'hidden';
          requestAnimationFrame(function () {
            if (lbTrack && lbSlides[i]) lbTrack.scrollLeft = lbSlides[i].offsetLeft;
            syncLbDots(i);
          });
        }
        function closeLb() {
          lb.hidden = true;
          document.documentElement.style.overflow = '';
        }

        slides.forEach(function (s) {
          s.addEventListener('click', function () {
            openLb(parseInt(s.getAttribute('data-l2-slide'), 10) || 0);
          });
        });
        if (lbClose) lbClose.addEventListener('click', closeLb);
        lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !lb.hidden) closeLb();
        });
        if (lbTrack) {
          lbTrack.addEventListener('scroll', function () {
            var w = lbTrack.clientWidth || 1;
            syncLbDots(Math.round(lbTrack.scrollLeft / w));
          }, { passive: true });
        }
      }

      setActive(0);
    }

    function initAccordion(root) {
      var acc = root.querySelector('[data-l2-accordion]');
      if (!acc) return;
      var items = acc.querySelectorAll('.l2-accordion__item');
      items.forEach(function (item) {
        var btn = item.querySelector('[data-l2-acc-btn]');
        var panel = item.querySelector('[data-l2-acc-panel]');
        if (!btn || !panel) return;
        btn.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');
          items.forEach(function (o) {
            o.classList.remove('is-open');
            var ob = o.querySelector('[data-l2-acc-btn]');
            var op = o.querySelector('[data-l2-acc-panel]');
            if (ob) ob.setAttribute('aria-expanded', 'false');
            if (op) op.hidden = true;
          });
          if (!isOpen) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            panel.hidden = false;
          }
        });
      });
    }

    function init() {
      document.querySelectorAll('[data-l2-buybox]').forEach(function (root) {
        if (root.__l2Init) return;
        root.__l2Init = true;
        initGallery(root);
        initAccordion(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-lifting2-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__l2Faq) return;
    window.__l2Faq = true;

    function initList(list) {
      var items = list.querySelectorAll('.l2-faq__item');
      items.forEach(function (item) {
        var btn = item.querySelector('[data-l2-faq-btn]');
        var panel = item.querySelector('[data-l2-faq-panel]');
        if (!btn || !panel) return;
        btn.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');
          items.forEach(function (o) {
            o.classList.remove('is-open');
            var ob = o.querySelector('[data-l2-faq-btn]');
            var op = o.querySelector('[data-l2-faq-panel]');
            if (ob) ob.setAttribute('aria-expanded', 'false');
            if (op) op.hidden = true;
          });
          if (!isOpen) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            panel.hidden = false;
          }
        });
      });
    }

    function init() {
      document.querySelectorAll('[data-l2-faq]').forEach(function (list) {
        if (list.__l2Init) return;
        list.__l2Init = true;
        initList(list);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-lifting2-promise"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__l2ScrollTop) return;
    window.__l2ScrollTop = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-l2-scroll-top]');
      if (!btn) return;
      var target = document.getElementById('l2-top') || document.querySelector('[data-l2-buybox]');
      if (!target) return;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-lifting2-results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__l2Rings) return;
    window.__l2Rings = true;

    var CIRC = 213.63;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function fill(ring) {
      var value = parseFloat(ring.getAttribute('data-value')) || 0;
      var progress = ring.querySelector('.l2-ring__progress');
      if (!progress) return;
      progress.style.strokeDashoffset = CIRC * (1 - value / 100);
    }

    function init() {
      var rings = document.querySelectorAll('[data-l2-ring]:not([data-l2-ring-done])');
      if (!rings.length) return;

      if (reduce || !('IntersectionObserver' in window)) {
        rings.forEach(function (r) { r.setAttribute('data-l2-ring-done', ''); fill(r); });
        return;
      }

      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.setAttribute('data-l2-ring-done', '');
            fill(entry.target);
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.4 });

      rings.forEach(function (r) { io.observe(r); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-lifting2-sticky-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__l2Sticky) return;
    window.__l2Sticky = true;

    function init() {
      var bar = document.querySelector('[data-l2-sticky]');
      if (!bar || bar.__l2Init) return;
      bar.__l2Init = true;

      var trigger = document.querySelector('[data-l2-sticky-trigger]');
      var closing = document.querySelector('[data-l2-closing]');
      var pastHero = false;
      var atClosing = false;

      function update() {
        var show = pastHero && !atClosing;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }

      if (trigger && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            pastHero = entry.boundingClientRect.top < 0;
            update();
          });
        }, { threshold: 0 }).observe(trigger);
      }

      if (closing && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            atClosing = entry.isIntersecting;
            update();
          });
        }, { threshold: 0.05 }).observe(closing);
      }

      update();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-serum2-buybox"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__s2Buybox) return;
    window.__s2Buybox = true;

    function initGallery(root) {
      var gallery = root.querySelector('[data-s2-gallery]');
      if (!gallery) return;
      var main = gallery.querySelector('[data-s2-main]');
      var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-s2-slide]'));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-s2-thumb]'));
      var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-s2-dot]'));
      var n = slides.length;
      if (!n) return;
      var index = 0;

      function desktop() { return window.matchMedia('(min-width: 768px)').matches; }

      function setActive(i) {
        index = (i % n + n) % n;
        slides.forEach(function (s, si) { s.classList.toggle('is-active', si === index); });
        thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === index); });
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === index); });
      }

      function goTo(i) {
        var target = (i % n + n) % n;
        if (!desktop() && main && slides[target]) {
          main.scrollTo({ left: slides[target].offsetLeft, behavior: 'smooth' });
        }
        setActive(target);
      }

      if (main) {
        main.addEventListener('scroll', function () {
          if (desktop()) return;
          var w = main.clientWidth || 1;
          var i = Math.round(main.scrollLeft / w);
          if (i !== index) setActive(i);
        }, { passive: true });
      }
      thumbs.forEach(function (t, ti) { t.addEventListener('click', function () { goTo(ti); }); });
      dots.forEach(function (d, di) { d.addEventListener('click', function () { goTo(di); }); });

      // full-screen lightbox
      var lb = root.querySelector('[data-s2-lightbox]');
      if (lb) {
        var lbTrack = lb.querySelector('[data-s2-lb-track]');
        var lbSlides = Array.prototype.slice.call(lb.querySelectorAll('[data-s2-lb-slide]'));
        var lbDots = Array.prototype.slice.call(lb.querySelectorAll('[data-s2-lb-dot]'));
        var lbClose = lb.querySelector('[data-s2-lb-close]');

        function syncLbDots(i) {
          lbDots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
        }
        function openLb(i) {
          lb.hidden = false;
          document.documentElement.style.overflow = 'hidden';
          requestAnimationFrame(function () {
            if (lbTrack && lbSlides[i]) lbTrack.scrollLeft = lbSlides[i].offsetLeft;
            syncLbDots(i);
          });
        }
        function closeLb() {
          lb.hidden = true;
          document.documentElement.style.overflow = '';
        }

        slides.forEach(function (s) {
          s.addEventListener('click', function () {
            openLb(parseInt(s.getAttribute('data-s2-slide'), 10) || 0);
          });
        });
        if (lbClose) lbClose.addEventListener('click', closeLb);
        lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !lb.hidden) closeLb();
        });
        if (lbTrack) {
          lbTrack.addEventListener('scroll', function () {
            var w = lbTrack.clientWidth || 1;
            syncLbDots(Math.round(lbTrack.scrollLeft / w));
          }, { passive: true });
        }
      }

      setActive(0);
    }

    function initAccordion(root) {
      var acc = root.querySelector('[data-s2-accordion]');
      if (!acc) return;
      var items = acc.querySelectorAll('.s2-accordion__item');
      items.forEach(function (item) {
        var btn = item.querySelector('[data-s2-acc-btn]');
        var panel = item.querySelector('[data-s2-acc-panel]');
        if (!btn || !panel) return;
        btn.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');
          items.forEach(function (o) {
            o.classList.remove('is-open');
            var ob = o.querySelector('[data-s2-acc-btn]');
            var op = o.querySelector('[data-s2-acc-panel]');
            if (ob) ob.setAttribute('aria-expanded', 'false');
            if (op) op.hidden = true;
          });
          if (!isOpen) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            panel.hidden = false;
          }
        });
      });
    }

    function init() {
      document.querySelectorAll('[data-s2-buybox]').forEach(function (root) {
        if (root.__s2Init) return;
        root.__s2Init = true;
        initGallery(root);
        initAccordion(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-serum2-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__s2Faq) return;
    window.__s2Faq = true;

    function initList(list) {
      var items = list.querySelectorAll('.s2-faq__item');
      items.forEach(function (item) {
        var btn = item.querySelector('[data-s2-faq-btn]');
        var panel = item.querySelector('[data-s2-faq-panel]');
        if (!btn || !panel) return;
        btn.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');
          items.forEach(function (o) {
            o.classList.remove('is-open');
            var ob = o.querySelector('[data-s2-faq-btn]');
            var op = o.querySelector('[data-s2-faq-panel]');
            if (ob) ob.setAttribute('aria-expanded', 'false');
            if (op) op.hidden = true;
          });
          if (!isOpen) {
            item.classList.add('is-open');
            btn.setAttribute('aria-expanded', 'true');
            panel.hidden = false;
          }
        });
      });
    }

    function init() {
      document.querySelectorAll('[data-s2-faq]').forEach(function (list) {
        if (list.__s2Init) return;
        list.__s2Init = true;
        initList(list);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-serum2-promise"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__s2ScrollTop) return;
    window.__s2ScrollTop = true;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-s2-scroll-top]');
      if (!btn) return;
      var target = document.getElementById('s2-top') || document.querySelector('[data-s2-buybox]');
      if (!target) return;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-serum2-results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__s2Rings) return;
    window.__s2Rings = true;

    var CIRC = 213.63;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function fill(ring) {
      var value = parseFloat(ring.getAttribute('data-value')) || 0;
      var progress = ring.querySelector('.s2-ring__progress');
      if (!progress) return;
      progress.style.strokeDashoffset = CIRC * (1 - value / 100);
    }

    function init() {
      var rings = document.querySelectorAll('[data-s2-ring]:not([data-s2-ring-done])');
      if (!rings.length) return;

      if (reduce || !('IntersectionObserver' in window)) {
        rings.forEach(function (r) { r.setAttribute('data-s2-ring-done', ''); fill(r); });
        return;
      }

      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.setAttribute('data-s2-ring-done', '');
            fill(entry.target);
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.4 });

      rings.forEach(function (r) { io.observe(r); });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-serum2-sticky-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__s2Sticky) return;
    window.__s2Sticky = true;

    function init() {
      var bar = document.querySelector('[data-s2-sticky]');
      if (!bar || bar.__s2Init) return;
      bar.__s2Init = true;

      var trigger = document.querySelector('[data-s2-sticky-trigger]');
      var closing = document.querySelector('[data-s2-closing]');
      var pastHero = false;
      var atClosing = false;

      function update() {
        var show = pastHero && !atClosing;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      }

      if (trigger && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            pastHero = entry.boundingClientRect.top < 0;
            update();
          });
        }, { threshold: 0 }).observe(trigger);
      }

      if (closing && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            atClosing = entry.isIntersecting;
            update();
          });
        }, { threshold: 0.05 }).observe(closing);
      }

      update();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
